import { Settings } from "@/components/ui/settings";
import { Text } from "@/components/ui/text";
import { useLanguagePreference } from "@/i18n";
import { useThemePreference } from "@/theme";
import { router } from "expo-router";
import { useTranslation } from "react-i18next";
import { TEST_IDS } from "../../../testIdDefinition";

export default function AppearanceSettings() {
    const { t } = useTranslation();
    const { preference: languagePreference } = useLanguagePreference();
    const { preference: themePreference } = useThemePreference();

    return (
        <Settings title={t("settings.display.title")}>
            <Settings.Item
                label={t("settings.display.theme")}
                group
                onPress={() => router.push("/settings/theme")}
                testID={TEST_IDS[TEST_IDS.SETTINGS_DISPLAY_THEME_LINK]}
            >
                <Text className="text-muted-foreground">
                    {t(`settings.display.theme-${themePreference}`)}
                </Text>
            </Settings.Item>
            <Settings.Item
                label={t("settings.display.language")}
                group
                onPress={() => router.push("/settings/language")}
                testID={TEST_IDS[TEST_IDS.SETTINGS_DISPLAY_LANGUAGE_LINK]}
            >
                <Text className="text-muted-foreground">
                    {t(`settings.display.language-${languagePreference}`)}
                </Text>
            </Settings.Item>
        </Settings>
    );
}
